export const APP_BUILD_VERSION: string = 'ccff12e-1793208442286';
